import { Tab, Tabs } from "@mui/material";
import { useState } from "react";
import DocumentReviewDocumentsTab from "./DocumentReviewDocumentsTab";
import WorkflowReviewQueue from "./components/WorkflowReviewQueue";
import CompanyDocumentsLanguageToggle from "./components/CompanyDocumentsLanguageToggle";
import {
  CompanyDocumentsLanguageProvider,
  useCompanyDocumentsLanguage,
} from "./i18n/CompanyDocumentsLanguageContext";

function DocumentReviewPageContent({
  setLayoutAction,
}) {
  const { t } = useCompanyDocumentsLanguage();
  const [tab, setTab] = useState(0);

  return (
    <div className="grid gap-4 min-w-0">
      <div className="flex justify-end">
        <CompanyDocumentsLanguageToggle />
      </div>

      <div className="bg-white rounded-lg shadow-sm px-4">
        <Tabs
          value={tab}
          onChange={(_, value) => setTab(value)}
          aria-label={t("adminReview.tabs.aria")}
        >
          <Tab
            label={t("adminReview.tabs.documents")}
          />
          <Tab
            label={t("adminReview.tabs.companyProfile")}
          />
        </Tabs>
      </div>

      {tab === 0 ? (
        <DocumentReviewDocumentsTab
          setLayoutAction={setLayoutAction}
        />
      ) : (
        <WorkflowReviewQueue />
      )}
    </div>
  );
}

export default function DocumentReviewPage(props) {
  return (
    <CompanyDocumentsLanguageProvider>
      <DocumentReviewPageContent {...props} />
    </CompanyDocumentsLanguageProvider>
  );
}
